export default {
  "custom": {
    linkedReference: 'Referencia vinculada',
    boot: 'Encender',
    shutDown: 'Apagar',
    notLinked: 'No vinculado',
    maxLinkedTip: 'Se permiten máximo 2 enlaces de {type}, revertido automáticamente a No vinculado',

    bar_Power: 'Energía',
    bar_Video: 'Cambio de video',
    bar_Vol: 'Volumen',
    bar_Audio: 'Cambio de audio',
    bar_Serial: 'Control serial',
    bar_Air: 'Aire acondicionado',
    bar_Projection: 'Pantalla de proyección',
    bar_Remote: 'Control remoto',
    bar_Matrix: 'IQShare Matrix',
    youMustSelectAllThreeImagesAtTheSameTime: 'Debe seleccionar las tres imágenes al mismo tiempo',
    notSelected: 'No seleccionado',
    choose: 'Elegir',
    disable: 'Deshabilitar',
    "longPressAndDrag": "Mantenga presionado y arrastre para ajustar el orden de la lista",
    "isrestoreDefault": "¿Desea restaurar al estado predeterminado?",
    "saveAndSync": "Guardar y sincronizar",
    "restoreDefault": "Restaurar valores predeterminados",
    "limitPNG": "¡Solo se pueden subir imágenes PNG!",
    "limit1M": "¡El tamaño de la imagen no puede superar 1 MB!",
    "selectTheImage": "Seleccionar imagen",
    "textsuggestions": "Se recomienda: ícono PNG blanco de 48*48 px, menor a 1 MB",
    "iconLibrary": "Biblioteca de iconos",
    "panelNavigationBarCustomization": "Barra de navegación del panel",
    "logoCustomization": "Logo del panel"
  },
  outlook: {
    privacy: 'Bind Microsoft Organization Privacy Agreement',
    privacyContent: "Agree to",
    AuthVerify4004One: 'Error al vincular: este inquilino de Microsoft (ID: ',
    AuthVerify4004Two: ') ya está ocupado por la organización [',
    AuthVerify4004Three: ']. Para volver a vincularlo, primero desvincúlelo de la organización original o use otro inquilino de Microsoft.',
    theMicrosoftTenantIsOccupied: 'El inquilino de Microsoft está ocupado',
    Viewtutorial: 'Ver tutorial de vinculación',
    checktenantID: 'Por favor verifique que su ID de inquilino, ID de aplicación y clave de aplicación sean correctos.',
    ErrorCode: 'Código de error:',
    AuthorizationFailed: 'Autorización fallida',
    Accesshasbeengranted: 'Se ha concedido acceso a Microsoft Graph API',
    successfullyauthorizedDescribe: 'Los permisos requeridos se han autorizado correctamente. Los datos de salas se sincronizarán automáticamente. Por favor cierre esta página.',
    Close: 'Cerrar',
    resourceID: 'ID de recurso',
    dialogTips: 'Consejos',
    theAuthorizationIsDeleted: 'Autorización eliminada',
    theBindingIsSuccessful: 'Vinculación exitosa',
    theUnbindingIsSuccessful: 'Desvinculación exitosa',
    unbindingFailed: 'Error al desvincular',
    theUnbindingHasBeenUnbound: 'Desvinculación cancelada',
    continueUnbinding: 'La sincronización con Outlook se detendrá y todos los eventos futuros se eliminarán. ¿Continuar desvinculando?',
    areYouSureAboutUnbinding: 'Todos los eventos futuros de Outlook se eliminarán y la sincronización se detendrá. Esta acción no se puede deshacer. ¿Confirmar desvinculación?',
    UnbindNotSynchronized: 'Después de vincular, los nuevos eventos de Outlook para esta sala se sincronizarán automáticamente (eventos pasados no se sincronizarán)',
    unbinding: 'Desvincular',
    bindUnableToSelect: 'Ya vinculado, no se puede seleccionar',
    permissAThird: 'Por favor autorice para vincular recursos de terceros',
    resourceMailbox: 'Correo de recurso:',
    PleasecheckID: '¡Error de autorización! Por favor verifique que su ID de inquilino, ID de aplicación y secreto de cliente sean correctos.',
    Waitingforauthorization: 'Esperando autorización...',
    Pleasecompletetheauthorization: 'Se abrió la página de inicio de sesión de Microsoft 365. Por favor inicie sesión con una cuenta de administrador para completar la autorización.',
    pleaseEnterTheTenantID: 'Ingrese el ID de inquilino',
    pleaseEnterTheClientID: 'Ingrese el ID de aplicación',
    pleaseEnterTheClientSecret: 'Ingrese el secreto de cliente',
    Authorizationcompleted: 'Autorización completada',
    Authorizelogin: 'Autorizar inicio de sesión Microsoft 365',
    ApplicationID: 'ID de inquilino',
    ClientID: 'ID de aplicación',
    ClientSecret: 'Secreto de cliente',
    registTipOne: 'Por favor siga la',
    registTipTwo: 'Guía de vinculación',
    registTipThree: 'Complete el registro de aplicación en Azure y configuración de permisos antes de completar los siguientes campos.',
    MicrosoftDescribe: 'Al vincular con Microsoft 365, las reuniones reservadas en Outlook/Teams se sincronizarán automáticamente con la Consola Q-NEX y el Programador de Salas.',
    Addcalendarservice: 'Configuración de sincronización de calendario',
    Lasttimesynchronization: 'Última sincronización',
    Allocated: 'Asignado',
    Total: 'Total',
    Conferenceroomresources: 'Recursos de sala de conferencias',
    Bindingtime: 'Hora de vinculación',
    Bindtheplatform: 'Plataforma de vinculación',
    Synchronousstate: 'Estado de sincronización',
    Organizationname: 'Nombre de organización',
    Bindthirdpartycalendar: 'Vincular calendario de terceros',
    TenantIDTip: 'Identificador único en Azure AD',
    ApplicationIDTip: 'ID de aplicación registrada en Azure',
    ApplicationSecretTip: 'Secreto de cliente generado en Azure para autenticación'
  },
  "meetingManager": {
    IdleDisplayTextTable: 'Texto de pantalla inactiva',
    IdleDisplayText: 'Texto de pantalla inactiva:',
    IdleDisplayTextContent: 'Texto mostrado cuando la sala está vacía (predeterminado: “Vacante”)',

    duplicateMeetingRoomName: 'Nombre de sala de reuniones duplicado',
    duplicateMeetingRoomNameContent: 'Ya existe una sala de reuniones llamada "{duplicate_content}". Introduzca otro nombre.',
    NumberOfRoomPanels: 'Número de paneles de sala',
    "Thecurrentterminalhasbeenboundtoanotherorganization": " El terminal actual ya está vinculado a otra organización.",
    "theTerminalNameOrIDIsDuplicated": "El nombre o ID del panel es el mismo",
    theRoomNameOrIDIsDuplicated: 'El nombre de la sala de reuniones o la ubicación ya existe.',
    "AddMeetingRoom": "Añadir sala de reuniones",
    "EditMeetingRoom": "Editar sala de reuniones",
    "MeetingRoomName": "Nombre de la sala de reuniones:",
    "Location": "Ubicación:",
    "ReservationApproval": "Aprobación de la reserva:",
    "ApprovalListYes": "sí",
    "ApprovalListNo": "no",
    "Capacity": "Capacidad:",
    "RoomStatus": "Estado de la sala:",
    "BindRoomDisplay": "Vincular panel de la sala:",
    "meeting_btnAdd": "Añadir",
    "meeting_btnEdit": "Editar",
    "meeting_btnBind": "Vincular dispositivo",
    "meeting_btnDel": "Eliminar",
    "meeting_tableRoomName": "Nombre de la sala de reuniones",
    "meeting_tableRoomPlace": "Ubicación",
    "meeting_tableAppointmentApproval": "Aprobación de la reserva",
    "meeting_tableCapacityForPeople": "Capacidad",
    "meeting_tableMeetingRoomStatus": "Estado de la sala",
    "meeting_tableAvaliable": "Disponible",
    "meeting_tableOutofService": "Fuera de servicio",
    "meeting_tableDoorBind": "Vincular puerta",
    "meeting_tableBindNPS": "Vincular NPS",
    "meeting_tableActions": "Acciones",
    "door_theNameOfTheTerminal": "Nombre del panel:",
    "door_deviceID": "ID del panel:",
    "door_Wallpaper": "Fondo de pantalla:",
    "door_Wallpaper_text": "Imagen recomendada: tamaño 1280x800, en formato PNG",
    "door_bindAMeetingRoom": "Vincular sala de reuniones:",
    "door_table_name": "Nombre del panel",
    "door_table_deviceID": "ID del panel",
    "door_table_status": "Estado",
    "door_table_ipAddress": "Dirección IP",
    "door_table_bindAMeetingRoom": "Vincular sala de reuniones",
    "door_btnAdd": "Añadir",
    "door_btnBatchAdd": "Añadir por lotes",
    "door_btnEdit": "Editar",
    "door_btnBatchEdit": "Editar por lotes"
  },
  "InputSourcesLinkage": {
    "configurationAddTitle": "Agregar configuración",
    "configurationEditTitle": "Editar configuración",
    "dialogConfigName": "Nombre de la configuración",
    "selectNMPAndNDP": "Dispositivos objetivo",
    "powerControl": "Control de energía",
    "executeCommand": "Hacer",
    "tableConfigName": "Nombre de la configuración",
    "selectConfig": "Por favor, seleccione configuración"
  },
  "NPS": {
    "Relay": "Relé",
    "RelaySettings": "Configuración del relé",
    "DevicePower": "Control de alimentación del dispositivo",
    "DeviceElevation": "Control de elevación",
    "LinageWithNPSPower": "Vinculación con la alimentación NPS",
    "PresentationSwitch": "Interruptor de presentación",
    "Duplicate": "Duplicar",
    "LinkagewithNPSPowe": "Vinculación con la alimentación NPS"
  },
  "PTZ": {
    "powerSupplyON": "Encender",
    "powerSupplyOFF": "Apagar",
    "LEFT": "Izquierda",
    "RIGHT": "Derecha",
    "UP": "Arriba",
    "DOWN": "Abajo",
    "HOME": "Inicio",
    "ENLARGE": "Ampliar",
    "REDUCTION": "Reducir",
    "StopMovement": "Detener movimiento",
    "STOP": "Detener zoom",
    "FOCUS": "Enfoque",
    "SET_PRESETS0": "AJUSTAR_PRESET0",
    "SET_PRESETS1": "AJUSTAR_PRESET1",
    "SET_PRESETS2": "AJUSTAR_PRESET2",
    "SET_PRESETS3": "AJUSTAR_PRESET3",
    "SET_PRESETS4": "AJUSTAR_PRESET4",
    "SET_PRESETS5": "AJUSTAR_PRESET5",
    "SET_PRESETS6": "AJUSTAR_PRESET6",
    "SET_PRESETS7": "AJUSTAR_PRESET7",
    "SET_PRESETS8": "AJUSTAR_PRESET8",
    "SET_PRESETS9": "AJUSTAR_PRESET9",
    "USE_PRESETS0": "USAR_PRESET0",
    "USE_PRESETS1": "USAR_PRESET1",
    "USE_PRESETS2": "USAR_PRESET2",
    "USE_PRESETS3": "USAR_PRESET3",
    "USE_PRESETS4": "USAR_PRESET4",
    "USE_PRESETS5": "USAR_PRESET5",
    "USE_PRESETS6": "USAR_PRESET6",
    "USE_PRESETS7": "USAR_PRESET7",
    "USE_PRESETS8": "USAR_PRESET8",
    "USE_PRESETS9": "USAR_PRESET9"
  },
  "schedule": {
    "startLinkPowerStart": "Encender (Relé CBXs)  ",
    "startLinkPowerStop": "Apagar (Relé CBXs)  ",
    "dehumidification": "Seco  ",
    "airSupply": "Ventilador  ",
    "masterControl": "principal:  ",
    "powerSupply": "Energía  ",
    "lockScreen": "Bloqueo  ",
    "RecordingControl": "Control de grabación  ",
    "RecordingControlSystem": "Sistema de captura de conferencias  ",
    "LiquidCrystal": "Panel interactivo de pantalla plana  ",
    "projector": "Proyector  ",
    "othertype": "Otro  ",
    "childLock": "Bloqueo infantil  ",
    "energySaving": "Ahorro de energía  ",
    "signalSourceSwitching": "Fuente de entrada  ",
    "other": "Otras características:  ",
    "otherFunction": "Función  ",
    "send": "Enviar  ",
    "ON": "ACTIVAR  ",
    "OFF": "DESACTIVAR  ",
    "btnAddSchedule": "Restaurar  ",
    "EditSchedulelist": "Modificar el programador  ",
    "AddSchedulelist": "Agregar un programador  ",
    "RestoreSchedulelist": "Restaurar  ",
    "btn": "Cancelar  ",
    "btnNewList": "Nuevo programador  ",
    "ListName": "Nombre  ",
    "Cannotquit": "Obligatorio  ",
    "NOCannotquit": "NO  ",
    "ListValidityPeriod": "Período de validez  ",
    "ListDescription": "Descripción  ",
    "currentSchedule": "Lista de programadores  ",
    "historySchedule": "Lista de historial  ",
    "selectTime": "Hora  ",
    "taskType": "Tipo de tarea  ",
    "selectBroadcasting": "Difusión  ",
    "selectDeviveControl": "Control de dispositivo  ",
    "newSchedule": "Nueva tarea  ",
    "newChecklist": "Nueva lista de verificación  ",
    "titleStatus": "Estado  ",
    "titleType": "Tipo  ",
    "titleStartTime": "Hora de inicio  ",
    "titleEndTime": "Hora de finalización  ",
    "titleRepeat": "Repetir  ",
    "titleName": "Nombre  ",
    "titleAction": "Acción  ",
    "tableEnabled": "Habilitado  ",
    "tablePaused": "Pausado  ",
    "tableEdit": "Modificar  ",
    "tableDelete": "Eliminar",
    "tableVolumeEdit": "Volumen de transmisión  ",
    "tableBroadcastTitle": "Título  ",
    "tableBroadcastContent": "Contenido  ",
    "tableBroadcastList": "Lista  ",
    "tableBroadcast": "Compulsivo  ",
    "btnRemoveCompletely": "Eliminar completamente  ",
    "btnEnabled": "Activado  ",
    "btnPaused": "En pausa  ",
    "btnDelete": "Eliminar  ",
    "repeat0": "LUN  ",
    "repeat1": "MAR  ",
    "repeat2": "MIÉ  ",
    "repeat3": "JUE  ",
    "repeat4": "VIE  ",
    "repeat5": "SÁB  ",
    "repeat6": "DOM  ",
    "dialogTitleAdd": "Nueva tarea de control de dispositivo  ",
    "dialogTitleEdit": "Editar tarea de control de dispositivo  ",
    "newBroadcastingSchedule": "Nueva tarea de transmisión  ",
    "editBroadcastingSchedule": "Editar tarea de transmisión  ",
    "chooseDevice": "Elegir dispositivo  ",
    "timeSetting": "Configuración de hora  ",
    "controlBroadcasting": "Opción de transmisión  ",
    "controlOption": "Opción de control  ",
    "scheduleName": "Nombre de la tarea:  ",
    "destination": "Destino  ",
    "timeTilte": "Hora  ",
    "repeatTitle": "Repetir  ",
    "dialogRepeat0": "LUN  ",
    "dialogRepeat1": "MAR  ",
    "dialogRepeat2": "MIÉ  ",
    "dialogRepeat3": "JUE  ",
    "dialogRepeat4": "VIE  ",
    "dialogRepeat5": "SÁB  ",
    "dialogRepeat6": "DOM  ",
    "dialogOnceType": "Una vez  ",
    "dialogRepeatType": "Repetir  ",
    "mainPower": "Energía principal  ",
    "powerControl": "Control de energía  ",
    "tableDisplayInputSwitch": "Interruptor de entrada de pantalla  ",
    "tableAirConditioning": "Aire acondicionado  ",
    "tableProjectionScreen": "Pantalla de proyección  ",
    "tableElectronicLock": "Bloqueo eléctrico  ",
    "interactiveFlatPanel": "Panel interactivo de pantalla plana  ",
    "displayInputSwitch": "Interruptor de entrada de pantalla  ",
    "speakerVolume": "Volumen de los altavoces  ",
    "MICVolume": "Volumen del micrófono  ",
    "ProjectionScreen": "Pantalla de proyección  ",
    "ElectronicLock": "Bloqueo eléctrico  ",
    "AirConditioning": "Aire acondicionado",
    "AirConditioningPower": "Potencia  ",
    "AirConditioningModel": "Modelo  ",
    "AirConditioningTEMP": "TEMP  ",
    "AirConditioningFanSpeed": "Velocidad del ventilador  ",
    "OPEN": "ABIERTO  ",
    "CLOSE": "CERRADO  ",
    "UP": "ARRIBA  ",
    "DOWN": "ABAJO  ",
    "PowerOFF": "APAGADO  ",
    "PowerON": "ENCENDIDO  ",
    "ModelAuto": "Automático  ",
    "ModelCool": "Enfriar  ",
    "ModelHeat": "Calentar  ",
    "ModelAir": "Lado del aire  ",
    "TEMPLow": "Bajo  ",
    "TEMPMiddle": "Medio  ",
    "TEMPHigh": "Alto  ",
    "btnSave": "Guardar  ",
    "btnNext": "SIGUIENTE  ",
    "StartTime": "Hora de inicio  ",
    "StopTime": "Hora de finalización  ",
    "Mandatory": "Obligatorio  ",
    "Video": "Vídeo & Audio  ",
    "Notification": "Notificación  ",
    "btnFile": "Seleccionar un archivo multimedia  ",
    "LastingTime": "Tiempo de duración  ",
    "textTitle": "Título  ",
    "textContent": "Contenido  ",
    "textTitleLetters": "Menos de 60 letras  ",
    "textContentLetters": "Menos de 320 letras  ",
    "CannotquitYES": "SÍ  ",
    "CannotquitNo": "No  ",
    "YES": "SÍ  ",
    "No": "No  ",
    "delTitleContent": "¿Está seguro de que desea eliminar este programador?  ",
    "delTitleListContent": "El programador eliminado será movido a la lista de historial y podrá ser restaurado  ",
    "deleListTitle": "¿Eliminar el programador?  ",
    "delTitleListContent1": "Eliminar el programador causará que las tareas asociadas se borren, por favor confirme.  ",
    "deleListTitle1": "¿Está seguro de que desea eliminar este programador?  ",
    "delTitle": "¿Eliminar?  ",
    "btnConfirm": "Confirmar  ",
    "coxAll": "TODO  ",
    "coxBroadcasting": "Transmisión  ",
    "coxDeviveControl": "Control de dispositivos  ",
    "rdMandatory": "SÍ  ",
    "noRdMandatory": "NO  ",
    "startDate": "Fecha de inicio  ",
    "endedDate": "Fecha de finalización  ",
    "or": "-  ",
    "broadcastingType": "Tipo",
    "ChooseTime": "Elegir hora  ",
    "ChooseDate": "Elegir fecha  ",
    "newScheduleList": "Nuevo programador  ",
    "editScheduleList": "Editar programador  ",
    "listName": "Nombre  ",
    "listValidityPeriod": "Período de validez  ",
    "listDescription": "Descripción  ",
    "cancel": "Cancelar  ",
    "confirm": "Confirmar  ",
    "save": "Guardar  ",
    "addSuccess": "¡Agregado con éxito!  ",
    "addError": "¡Error al agregar!  ",
    "editSuccess": "¡Editado con éxito!  ",
    "editError": "¡Error al editar!  ",
    "delSuccess": "¡Eliminado con éxito!  ",
    "delError": "¡Error al eliminar!  ",
    "restoreSuccess": "Lista de programadores restaurada con éxito  ",
    "restoreError": "Error al recuperar la lista de programadores  ",
    "restoreTitleContent": "Este horario entra en conflicto con el horario de la lista, por favor seleccione nuevamente  ",
    "Enabled": "Activado  ",
    "Paused": "En pausa  ",
    "Title": "Título:  ",
    "Content": "Contenido:  ",
    "errorScheduleNameRequired": "El nombre de la tarea debe ser completado  ",
    "errorDeviceRequired": "Por favor, seleccione el dispositivo objetivo  ",
    "deleTitle": "¿Está seguro de que desea eliminar esta tarea?  ",
    "loopList": "Lista de repeticiones  ",
    "errorPleaseDateRange": "Por favor, seleccione un rango de fechas  ",
    "addError_2009": "Nombre de programador duplicado  ",
    "conflicts": "El tiempo de la tarea entra en conflicto con los siguientes:  ",
    "Pleaseagain": "Por favor ingrese nuevamente  ",
    "errorScheduleName": "Nombre de la tarea  ",
    "errorListName": "Nombre del programador  ",
    "today": "Hoy  ",
    "yesterday": "Ayer  ",
    "thisWeek": "Esta semana  ",
    "lastWeek": "La semana pasada  ",
    "lastMonth": "El mes pasado  ",
    "thisMonth": "Este mes  ",
    "times": "Veces  ",
    "TimeConflicts": "Conflictos de tiempo  ",
    "editError_2006": "Dispositivo no encontrado  ",
    "editError_2010": "Nombre de tarea duplicado  ",
    "ListTimeExpired": "El tiempo del programador ha expirado, por favor seleccione nuevamente  ",
    "TimeExpired": "Tiempo expirado  ",
    "ControlOption": "Falta la opción de control  ",
    "Pleaseleastone": "Por favor, seleccione al menos una opción de control  ",
    "Enter": "Entrar  ",
    "TitleFilled": "El título debe ser completado  ",
    "ContentFilled": "El contenido debe ser completado  ",
    "PleaseMediaFile": "Por favor, seleccione un archivo multimedia  ",
    "PleaseSchedule": "Por favor, seleccione una tarea  ",
    "delTitleScheduleContent": "La tarea eliminada no puede ser recuperada.  ",
    "deleTitleSchedule": "¿Está seguro de que desea eliminar esta tarea?  ",
    "deleteScheduleTitle": "Por favor, seleccione la tarea para eliminar  ",
    "PleaseFillColumn": "Por favor, complete el nombre del programador  ",
    "PleaseDate": "Por favor, seleccione la fecha  ",
    "Previous": "Anterior  ",
    "RemoteControl": "Control remoto  ",
    "taskhasexpired": "Esta tarea ha expirado, por favor contacte al creador para actualizar el tiempo.  ",
    "execute": "Ejecutar  ",
    "broadcastingList": "Lista de difusión  ",
    "volumeSuccess": "Volumen configurado con éxito  ",
    "volumeFailed": "Error al configurar el volumen  "
  },
  "Automation": {
    "nameDuplicate": "Nombre de tarea duplicado automáticamente  ",
    "Automation": "Automatización  ",
    "if": "Si:  ",
    "ifContent": "La sección 'SI' le permite configurar condiciones basadas en los datos de los sensores. Elija el sensor y especifique condiciones como 'Temperatura > 26°C'.  ",
    "then": "Entonces:  ",
    "thenContent": "La sección 'ENTONCES' le permite elegir dispositivos y definir acciones para ellos. Seleccione dispositivos como NMP1, NMP2 y especifique acciones como 'Encender + Enfriar' para los aires acondicionados.  ",
    "btnDelete": "Eliminar  ",
    "Add": "Agregar  ",
    "taskName": "Nombre de la tarea  ",
    "dialogTaskName": "Nombre de la tarea:  ",
    "Statue": "Estado  ",
    "DevicesApplied": "Dispositivos aplicados  ",
    "Operation": "Operación  ",
    "AirConditioningPower": "Energía  ",
    "AirConditioningModel": "Modelo  ",
    "AirConditioningFanSpeed": "Velocidad del ventilador  ",
    "bold": "Oscilación  ",
    "selectTask": "Por favor seleccione la tarea  ",
    "autoTaskAdd": "Agregar tarea de automatización  ",
    "autoTaskEdit": "Editar tarea de automatización  ",
    "Destination": "Destino  ",
    "selectConditions": "Por favor especifique la acción que desea realizar.  ",
    "selectDestination": "Por favor seleccione el/los dispositivo(s) objetivo(s) NMP, luego especifique la acción que desea realizar  ",
    "AirConditioningTEMP": "Temperatura  ",
    "AirConditioningHumidness": "Humedad  ",
    "noData": "No se han agregado tareas aún. Haga clic en \"Agregar\" para agregar tareas.  "
  },
  "rs232Translation": {
    "reliveBinding": "Desvincular  ",
    "RELIVEBINDING": "Desvincular",
    "ACTO": "ACTO",
    "AMENA": "AMENA",
    "APPOTRONICS": "APPOTRONICS",
    "APTI": "APTI",
    "ASEE": "ASEE",
    "ASK": "ASK",
    "AUCMA": "AUCMA",
    "AUX": "AUX",
    "BARCO": "BARCO",
    "BENQ": "BENQ",
    "BOERKA": "BOERKA",
    "BOXLIGHT": "BOXLIGHT",
    "Canon": "Canon",
    "CARRIER": "CARRIER",
    "CHANGHONG": "CHANGHONG",
    "CHIGO": "CHIGO",
    "CHRISTIE": "CHRISTIE",
    "Chunlan": "Chunlan",
    "COSTAR": "COSTAR",
    "CROWN": "CROWN",
    "CX": "CX",
    "DAEWOO": "DAEWOO",
    "DAIKIN": "DAIKIN",
    "DIGITEL": "DIGITEL",
    "DONGBAO": "DONGBAO",
    "EIKI": "EIKI",
    "electra": "electra",
    "Electrolux": "Electrolux",
    "EPSON": "EPSON",
    "FEILU": "FEILU",
    "FOUNDER": "FOUNDER",
    "Frestec": "Frestec",
    "Fujitsu": "Fujitsu",
    "Galanz": "Galanz",
    "GREE": "GREE",
    "Haier": "Haier",
    "Hisense": "Hisense",
    "HITACHI": "HITACHI",
    "HP": "HP",
    "HUIFENG": "HUIFENG",
    "InFocus": "InFocus",
    "IQ": "IQ",
    "JVC": "JVC",
    "KODAK": "KODAK",
    "LANGER": "LANGER",
    "LENOVO": "LENOVO",
    "LG": "LG",
    "LITTLESWAN": "LITTLESWAN",
    "LUMENS": "LUMENS",
    "McQuay": "McQuay",
    "Microtek": "Microtek",
    "Mitsubishi": "Mitsubishi",
    "NANFENG": "NANFENG",
    "NEC": "NEC",
    "OPTOMA": "OPTOMA",
    "PALOROID": "PALOROID",
    "panisonic": "panisonic",
    "PHILIP": "PHILIP",
    "PJD": "PJD",
    "PLUS": "PLUS",
    "POLAROID": "POLAROID",
    "PROPIX": "PROPIX",
    "PROXIMA": "PROXIMA",
    "RAYBO": "RAYBO",
    "ROWA": "ROWA",
    "Samsung": "Samsung",
    "SANYO": "SANYO",
    "SAST": "SAST",
    "SEEMILE": "SEEMILE",
    "SHARP": "SHARP",
    "shengfeng": "shengfeng",
    "Shinco": "Shinco",
    "shuanglu": "shuanglu",
    "Sony": "Sony",
    "SOVA": "SOVA"
  },
  "VcbEdit": {
    "VcbNameNoNull": "El nombre del CBX no puede estar vacío  ",
    "BrandNoNull": "La marca no puede estar vacía  ",
    "ModelNoNull": "El modelo no puede estar vacío  ",
    "AcNoNull": "El control de aire acondicionado no puede estar vacío  ",
    "RcNoNull": "El control remoto no puede estar vacío"
  },
  "route": {
    customize: 'Personalizar',
    "InputSourcesLinkage": "Vinculación de fuentes de entrada  ",
    "Automation": "Automatización  ",
    "dashboard": "Dashboard",
    "i18n": "I18n  ",
    "organizationMge": "Grupos  ",
    "userMge": "Usuarios  ",
    "authorityMge": "Permiso  ",
    "roleMge": "Roles  ",
    "equipmentMge": "Dispositivos  ",
    "workstationMge": "Medios",
    "cloudDiskMge": "Almacenamiento",
    "operationLog": "Registro de operaciones  ",
    "setting": "Configuración  ",
    "resourceMge": "Gestión de recursos  ",
    "storageMge": "Gestión de almacenamiento  ",
    "interfaceRename": "Renombrar interfaz  ",
    "processorManager": "Administrador de procesadores  ",
    "projectorCode": "Gestión de códigos de serie  ",
    "projectorCodeSetting": "Configuraciones de códigos de serie  ",
    "RepairLog": "Registro de reparaciones  ",
    "remoteControl": "Código de control remoto  ",
    "acCode": "Código de control de aire acondicionado  ",
    "cardMge": "Tarjetas  ",
    "cardLog": "Registro de uso de tarjetas  ",
    "cardManager": "Administrador de tarjetas  ",
    "meetingManager": "Reunión  ",
    "meetingRoomManager": "Gestión de salas  ",
    "meetingDoorManager": "Gestión de paneles"
  },
  "navbar": {
    "logOut": "Cerrar sesión  ",
    "dashboard": "Tablero de control  ",
    "screenfull": "Pantalla completa  ",
    "language": "Idioma  ",
    "userConsole": "Consola Q-NEX  ",
    "BackTianwa": "Volver a Tianwa"
  },
  "feedback": {
    "Feedback": "Comentarios  ",
    "email": "Por favor, deje su correo electrónico para recibir nuestros comentarios.  ",
    "content": "Bienvenido y deje mensajes para mejorar nuestros productos. Gracias por sus comentarios.  ",
    "submit": "Enviar  ",
    "emailNoEmpty": "El correo electrónico no puede estar vacío  ",
    "emailTrueRule": "Por favor ingrese el formato de correo electrónico correcto  ",
    "contentNoEmpty": "El contenido no puede estar vacío  ",
    "feedbackSuccess": "Éxito en los comentarios  ",
    "feedbackFailed": "Fallo en los comentarios  ",
    "emailNoChinese": "El buzón no puede tener caracteres chinos  ",
    "emailLength": "Entre 5 y 100 caracteres de longitud  ",
    "GroupNameLength": "Entre 1 y 20 caracteres de longitud  ",
    "emailSpecialString": "Este cuadro de entrada no puede contener cadenas especiales"
  },
  "login": {
    "title": "BIENVENIDO  ",
    "logIn": "Iniciar sesión  ",
    "username": "Nombre de usuario  ",
    "password": "Contraseña  ",
    "any": "cualquiera  ",
    "thirdparty": "O conéctese con  ",
    "thirdpartyTips": "¡No se puede simular de forma local, así que por favor combine su propia simulación de negocio!  ",
    "placeholder": "[  \n  \"Nombre de usuario\",  \n  \"Contraseña\",  \n  \"Código de verificación\"  \n]  ",
    "userNameTitle": "¡Nombre de usuario incorrecto!  ",
    "forget": "¿Olvidado?  ",
    "loginTitle0": "¡Inicio de sesión exitoso!  ",
    "loginTitle1000": "¡Nombre de usuario o contraseña incorrectos!  ",
    "loginTitle1001": "¡El nombre de usuario y la contraseña deben completarse!  ",
    "loginTitle1002": "¡El código de verificación debe completarse!  ",
    "loginTitle1003": "¡El estado del usuario es ilegal, inicio de sesión fallido!  ",
    "loginTitle1004": "¡Error de código de verificación!  ",
    "loginTitle1005": "¡No se ha iniciado sesión, por favor inicie sesión primero!  ",
    "loginTitleUserName": "¡El nombre de usuario debe completarse!  ",
    "loginTitlePwd": "¡La contraseña debe completarse!  ",
    "loginTitleVercode": "¡El código de verificación debe completarse!  ",
    "errorLogin": "¡Derechos de usuario insuficientes, no se puede iniciar sesión!  ",
    "titleLoginNameFormat": "Debe consistir en caracteres, o caracteres y números."
  },
  "organizationMge": {
    "CanTDragTop": "No se puede mover a la raíz  ",
    "prefixCannotBeEmpty": "El prefijo de la cuenta de superadministrador no puede estar vacío  ",
    "enterEnglishLetters": "El prefijo de la cuenta de superadministrador solo puede contener letras inglesas y números  ",
    "dateNotSelected": "No se ha seleccionado la fecha de inicio del período de validez del servicio de transmisión  ",
    "btnAddChild": "Agregar subordinado  ",
    "btnAddSibling": "Agregar hermano  ",
    "title": "Consejo:  ",
    "againTitle": "Por favor, confirme nuevamente:  ",
    "sort": "Ordenar:  ",
    "realName": "Nombre real:  ",
    "titleShooleRq": "Este campo debe ser llenado  ",
    "titleShooleNub": "menos de 100 letras  ",
    "schoolName": "Nombre del grupo:  ",
    "type": "Tipo de grupo:  ",
    "accountPrefix": "Cuenta de administrador:  ",
    "organization": "Distribuidor  ",
    "terminalMechanism": "Usuario final  ",
    "equipmentNum": "Número de dispositivo:  ",
    "organizationNum": "Número de grupos de terminales:  ",
    "adminName": "Cuenta de administrador:  ",
    "adminPwd": "Contraseña de administrador:  ",
    "edit": "Editar  ",
    "add": "Agregar  ",
    "del": "Eliminar  ",
    "addSuccess": "¡Agregado con éxito!  ",
    "addError": "¡Error al agregar!  ",
    "editSuccess": "¡Modificado con éxito!  ",
    "editError": "¡Error al modificar!  ",
    "delSuccess": "¡Eliminado con éxito!  ",
    "delWarn": "No se puede eliminar este grupo con dispositivos vinculados  ",
    "delError": "¡Error al eliminar!  ",
    "cancel": "Cancelar  ",
    "confirm": "Confirmar  ",
    "save": "Guardar  ",
    "TrialWorkstation": "Actualmente está en el estado de prueba, solo puede transmitir y transmitir en vivo a un máximo de 3 dispositivos terminales.  ",
    "Normal": "Normal  ",
    "NormalWorkstation": "El período de validez de su servicio de transmisión es desde  ",
    "to": "hasta  ",
    "Advent": "Adviento  ",
    "AdventWorkstationOne": "Su servicio de transmisión expirará el  ",
    "AdventWorkstationTwo": ", por favor, póngase en contacto con su agente para renovar a tiempo para un uso normal.  ",
    "Expired": "Caducado  ",
    "ExpiredWorkstation": "Su servicio de transmisión ha caducado, por favor, póngase en contacto con su agente para renovarlo a tiempo.  ",
    "admin": "Administrador:  ",
    "serviceState": "Servicio de medios de transmisión:  ",
    "serviceStateLIST": "Servicio de medios de transmisión  ",
    "ValidityPeriod": "Período de validez:  ",
    "ValidityPeriodLIST": "Período de validez  ",
    "Trial": "Prueba  ",
    "Permanent": "Permanente  ",
    "AnnualBilling": "Facturación anual  ",
    "mediaValidityPeriod": "Período de validez:  ",
    "mediaValidityPeriodLIST": "Período de validez  ",
    "contactInformation": "Detalles de contacto (para el recordatorio de renovación de servicio de transmisión de medios)  ",
    "company": "Nombre de la empresa:  ",
    "email": "Correo electrónico:  ",
    "phone": "Teléfono:  ",
    "StartDate": "Fecha de inicio  ",
    "EndDate": "Fecha de finalización  ",
    "To": "Hasta  ",
    "TerminalName": "Nombre del usuario final  ",
    "Competence": "Administrador  ",
    "operate": "Operar  ",
    "statusFilter": "Filtro de estado  ",
    "disableStreaming": "¿Está seguro de que desea desactivar el servicio de transmisión?  ",
    "enableStreaming": "¿Está seguro de que desea activar el servicio de transmisión?  ",
    "disableStreamingContent": "Cuando el servicio de transmisión está desactivado, el grupo no podrá utilizar las funciones relacionadas con la transmisión y la transmisión en vivo.  ",
    "enableStreamingContent": "Por favor, modifique el período de validez para los grupos con servicio de transmisión caducado.  ",
    "search": "Introduzca el nombre de la organización  ",
    "optionsYearZero": "Por favor elija",
    "optionsYearOne": "Un año  ",
    "optionsYearTwo": "Dos años  ",
    "optionsYearThree": "Tres años  ",
    "dialogName": "Nombre:  ",
    "detTitle": "Eliminar el grupo causará que todo el contenido debajo de él se elimine también.  ",
    "groupDelTitle": "¿Estás seguro de que deseas eliminar este grupo?  ",
    "delTitle": "¿Eliminar?  ",
    "delTitleContent": "El contenido seleccionado será eliminado de la base de datos. Esta operación no puede deshacerse. ¿Estás seguro de que deseas continuar?  ",
    "delCancelButton": "Cancelar  ",
    "delConfirmButton": "Confirmar  ",
    "copySuccess": "El contenido ha sido copiado al portapapeles.  ",
    "copyError": "El navegador no admite la copia automática  ",
    "error1200": "Nombre de grupo duplicado  ",
    "error1201": "Duplicación de grupo o ID de grupo  ",
    "error1202": "Se ha excedido el número máximo de dispositivos conectables  ",
    "error1203": "Nombre de usuario duplicado  ",
    "error1204": "Ya existe un grupo con el mismo nombre en el mismo nivel  ",
    "error1210": "Por favor, ingrese la contraseña del administrador  ",
    "warningGroup": "¡Elija un grupo!  ",
    "warningTerminal": "¡El grupo terminal no puede crear subgrupos!  ",
    "account": "Cuenta duplicada  ",
    "titleOrganization": "iNota: El prefijo de la cuenta se define a nivel de la organización. Todas las cuentas de usuario de esta organización compartirán el mismo prefijo.",
    "all": "Todo"
  },
  "userMge": {
    "nickName": "Apodo  ",
    "contentWithBrand": "Ingresa la marca o el modelo  ",
    "contentwithIp": "Buscar por nombre de dispositivo o dirección IP.  ",
    "btnAdd": "Nuevo usuario  ",
    "btnDelete": "Eliminar  ",
    "btnDownload": "Descargar plantilla  ",
    "btnImport": "Importación masiva  ",
    "btnExport": "Descargar  ",
    "btnDisable": "Deshabilitar  ",
    "btnEnable": "Habilitar  ",
    "accountType": "Filtrar por rol  ",
    "organizationName": "Filtrar por grupo  ",
    "content": "Buscar  ",
    "systemAccount": "ID de usuario  ",
    "idCardNumber": "ID de empleado  ",
    "customizeAccount": "Cuenta personalizada  ",
    "userName": "Nombre  ",
    "licenseNum": "Número de licencia  ",
    "phone": "Teléfono  ",
    "email": "Correo electrónico  ",
    "role": "Rol  ",
    "status": "Estado  ",
    "affiliatedOrganization": "Grupos  ",
    "roleTypeList1": "Usuario general  ",
    "roleTypeList2": "Estudiante  ",
    "roleTypeList3": "Padre  ",
    "roleTypeList101": "Agente Admin  ",
    "roleTypeList102": "Administrador  ",
    "roleTypeList301": "Super Admin  ",
    "userStatus1": "Activo  ",
    "userStatus2": "Bloqueado  ",
    "userStatus3": "Eliminar  ",
    "operate": "Acciones  ",
    "dialogName": "Apodo:  ",
    "dialogUserName": "ID de usuario:  ",
    "dialogUserNameDefined": "Nombre de usuario:  ",
    "dialogPassword": "Contraseña:  ",
    "dialogID": "ID de empleado:  ",
    "dialogRole": "Rol:  ",
    "dialogEmail": "Correo electrónico:  ",
    "dialogPhone": "Teléfono:  ",
    "dialogGroup": "Grupo:  ",
    "addUser": "Nuevo usuario  ",
    "editUser": "Editar usuario  ",
    "addSuccess": "¡Agregado con éxito!  ",
    "addError": "¡Error al agregar!  ",
    "editSuccess": "¡Editado con éxito!  ",
    "editError": "¡Error al editar!  ",
    "delSuccess": "¡Eliminado con éxito!",
    "delError": "¡Error al eliminar!  ",
    "cancel": "Cancelar  ",
    "confirm": "Confirmar  ",
    "save": "Guardar  ",
    "tableDel": "Eliminar  ",
    "tableEdit": "Editar  ",
    "selectRoles": "Seleccionar roles  ",
    "delTitle": "¿Eliminar?  ",
    "delTitleContent": "El contenido seleccionado será eliminado de la base de datos. Esta operación no se puede deshacer. ¿Está seguro de que desea continuar?  ",
    "delCancelButton": "Cancelar  ",
    "delConfirmButton": "Confirmar  ",
    "titleRealNameRq": "Este campo debe ser llenado  ",
    "titleRealNameFormat": "Elija un nombre de usuario que contenga solo letras y números.  ",
    checkPasswordTitleTwo: 'Por favor, establezca una contraseña de al menos 6 caracteres que incluya letras y números. Se permiten caracteres especiales (sin restricciones).',
    checkPasswordTitle: 'La contraseña debe tener al menos 6 caracteres y no puede ser solo números',
    "titlePhoneFormat": "El teléfono solo puede contener números, (), + y -.  ",
    "phoneFilled": "El teléfono debe ser llenado.  ",
    "titleEmaileFormat": "Error en el formato del correo electrónico.  ",
    "emaileFilled": "El correo electrónico debe ser llenado.  ",
    "titlUserNameDefinedNub": "El nombre de usuario no puede exceder los 30 caracteres  ",
    "titlRealNameNub": "El nombre no puede exceder los 30 caracteres.  ",
    "titlRealNameField": "El nombre debe ser llenado.  ",
    "thisPasswordField": "La contraseña debe ser llenada.  ",
    "titlPassWordNub": "La contraseña debe tener entre 6 y 30 caracteres  ",
    "enableStatus": "Activar usuario  ",
    "stopStatus": "Desactivar usuario  ",
    "enableContent": "¿Está seguro de que desea activar al usuario?  ",
    "stopContent": "¿Está seguro de que desea desactivar al usuario?  ",
    "error1400": "El nombre de usuario ya existe, intente de nuevo  ",
    "error1401": "¡El ID de usuario ya existe y la operación falló!  ",
    "error1402": "El grupo no existe, ¡la importación falló!  ",
    "error1403": "Datos incorrectos  ",
    "error1404": "Permisos insuficientes  ",
    "selUser": "¡Por favor seleccione un usuario!  ",
    "error1405": "Error al obtener el rol  ",
    "error1406": "El formato de los datos del usuario importado es incorrecto  ",
    "error1407": "El correo electrónico ya existe y la operación falló.  ",
    "error1408": "El teléfono ya existe y la operación falló.  ",
    "error1900": "El parámetro accesado está vacío  ",
    "error1610": "Por favor, use el rol de administrador del terminal para realizar las operaciones correspondientes  ",
    "errorOrgIdList": "¡El grupo no puede estar vacío!  ",
    "Bindsucceeded": "Vinculación exitosa  ",
    "Bindfailed": "Error al vincular  ",
    "tableuserName": "Nombre de usuario  ",
    "titleDevice": "Dispositivo  ",
    "bindDevice": "Dispositivo vinculado  ",
    "Bindcontrollable": "¿Vincular el dispositivo controlable ahora?  "
  },
  "devicesMge": {
    mustChooseOne: 'Cuando se selecciona el control remoto inteligente, se debe elegir al menos un comando de control',
    customName: 'Nombre personalizado',
    "testAcCode": "Probar nuevo código de control A/C",
    "Online": "En línea",
    "Offline": "Fuera de línea",
    "unBindConfirm": "Confirmar para desvincular Serial",
    "unBindConfirm485": "Confirmar para desvincular RS485",
    "notYetBoundRS232": "El dispositivo aún no está vinculado a un código Serial. Puede ir a Dispositivo > Código de Control Serial para añadirlo.",
    "RsFollowingFunctions": "Se pueden realizar las siguientes funciones mediante los códigos Serial:",
    "Unbind": "Desvincular",
    "Limit255": "El nombre del archivo contiene un máximo de 255 caracteres",
    "clear": "Borrar",
    "equipName": "Nombre del dispositivo",
    "equipType": "Tipo",
    "selectField": "Seleccione un archivo",
    "dialogTip": "*Si el cuadro de entrada a la derecha está vacío, el contenido a la izquierda se muestra por defecto",
    "dialogTipSingle": "*Si un solo dispositivo no está nombrado, siga el nombre \"TODOS\"",
    "cantDelTemplateOne": "El CBX de",
    cantDelTemplateTwo: 'El CBX del dispositivo "{deviceName}" es una plantilla. ¿Está seguro de que desea eliminarlo?',
    "templateTitle": "Reemplazo de plantilla",
    "templateContentOne": "El nombre del dispositivo \"",
    "templateContentTwo": " se ha configurado como la plantilla CBX común. ¿Estás seguro de configurar el dispositivo actual como la plantilla?",
    "vcbNoTemplateNoSave": "No se puede guardar sin plantilla",
    "vcbAcControl": "Seleccionar un dispositivo A/C",
    "vcbRemoteControl": "Seleccionar un dispositivo de control remoto",
    "vcbPOWERControl": "Control de energía",
    "vcbRS232Control": "Control Serial",
    "vcbIRControl": "Control IR",
    "vcbSetting": "Configuración de CBX",
    "editVcb": "Edición de CBX",
    "vcbName": "Nombre de CBX",
    "iot": "Control de CBX",
    "saveAsTemplate": "Guardar como plantilla",
    saveAsTemplatereplenish: 'Seleccione varios dispositivos para utilizar esta plantilla en el Centro de control',
    "Upload": "Subir",
    "Select": "Seleccionar",
    "InputDeviceID": "ID del dispositivo de entrada",
    "editNameTips": "* El contenido a la izquierda se muestra por defecto cuando el cuadro de entrada a la derecha está vacío.",
    "_RS232A": "Interfaz uno",
    "_RS232B": "Interfaz dos",
    "institutionDirectory": "Directorio de la institución",
    "projectionScreenLinkageSetting": "Configuración del control de pantalla de proyección",
    "screenLiftingLinkageDisplaySwitch": "Control de enlace entre la pantalla de proyección y la pantalla:",
    "stopLinkage": "Desactivar (Controlar la pantalla de proyección por separado)",
    "Enable": "Activar (Controlar simultáneamente la pantalla de proyección y la pantalla)",
    "btnAddDevice": "Agregar dispositivo",
    "btnImportDevice": "Importación masiva de dispositivos",
    "btnDel": "Eliminar",
    "btnEdit": "Editar",
    "tableIpAddress": "Dirección IP",
    "MACAddress": "Dirección MAC",
    "firmwareVersion": "Versión del firmware",
    "NA": "No disponible",
    "tableDeviceName": "Nombre del dispositivo",
    "tableStatus": "Estado",
    "tableVideoSwitch": "Interruptor de video",
    "tableAudio": "Distribución A/V",
    "tablePowerControl": "Control de energía",
    "tableRS232": "Control serie",
    "tableIR": "Control IR",
    "tableRFIDCard": "Tarjeta IC",
    "tableControlPanel": "Panel de control",
    "tableOrganization": "Grupos",
    "tableActions": "Acciones",
    "dialogAddTitle": "Agregar dispositivo",
    "dialogEditTitle": "Editar dispositivo",
    "dialogBatchAddTitle": "Agregar dispositivos masivamente",
    "dialogBatchEditTitle": "Editar dispositivos masivamente",
    "btnCancel": "Cancelar",
    "Devices": "Dispositivos:",
    "ProjectorCode": "Código Serial:",
    "Group": "Grupo:",
    "btnBatchAdd": "Agregar masivamente",
    "delTitle": "¿Eliminar?",
    "delTitleContent": "Los componentes seleccionados serán eliminados de la base de datos. Este proceso es irreversible. ¿Estás seguro de que deseas continuar?",
    "delCancelButton": "Cancelar",
    "delConfirmButton": "Confirmar",
    "addError": "¡Error al agregar!",
    "editSuccess": "¡Edición exitosa!",
    "editError": "¡Error al editar!",
    "delSuccess": "¡Eliminación exitosa!",
    "delError": "¡Error al eliminar!",
    "content": "Buscar",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "save": "Guardar",
    "tableDel": "Eliminar",
    "tableEdit": "Editar",
    "selectRoles": "Seleccionar roles",
    "selectType": "Por favor, selecciona un tipo",
    "selectDevices": "Por favor, selecciona un dispositivo",
    "titleRealNameRq": "Este campo debe ser completado",
    "titleRealNameNub": "Menos de 100 caracteres",
    "titlPassWordNub": "Menos de 15 caracteres",
    "error1900": "El parámetro accedido está vacío",
    "error2000": "Se ha superado el número máximo de dispositivos conectables",
    "error2001": "El código del dispositivo importado es incorrecto o aún no ha sido ingresado en el sistema.",
    "error2002": "Nombre de dispositivo duplicado importado",
    "error2003": "El ID de dispositivo importado ya ha sido utilizado",
    "error2004": "Error en los datos importados",
    "error2005": "El nombre de la marca o del modelo coincide con datos existentes en el sistema; por favor, renombre la marca o el modelo.",
    "error2008": "Este dispositivo ya está asociado con otro grupo",
    "notDevicesName": "El nombre del dispositivo no puede estar vacío",
    "notDevicesNO": "El ID del dispositivo no puede estar vacío",
    "dialogDevicesName": "Nombre del dispositivo:",
    "dialogDevicesID": "ID del dispositivo:",
    "dialogProjectorCode": "Código Serial:",
    "dialogGroup": "Grupo:",
    "dialogSel": "Por favor elija",
    "errorOrgIdList": "¡El grupo no puede estar vacío!",
    "errorDevicesName": "¡El nombre del dispositivo no puede estar vacío!",
    "errorDevicesNo": "¡El ID del dispositivo no puede estar vacío!",
    "dialogTiltleDevices": "Dispositivos:",
    "uploadSuccess": "Carga exitosa",
    "addSuccess": "Añadir exitoso",
    "ChooseGroups": "Elegir los grupos",
    "ChooseIcon": "Elegir icono",
    "dialogDevicesTitle": "Los ajustes de parámetros se aplican a los siguientes dispositivos",
    "backDevice": "Atrás",
    "bootSetting": "Opciones de inicio",
    "nmpOpenSetting": "Ajustes de encendido",
    "npsOpenSetting": "Ajustes de encendido",
    "nmpPowerSettings": "Ajustes de energía",
    "npsPowerSettings": "Ajustes de energía",
    "nmpInterfaceSettings": "Ajustes de interfaz",
    "npsInterfaceSettings": "Ajustes de interfaz",
    "nmpDefaultChannel": "Ajustes de canal por defecto",
    "nmpCloseSetting": "Ajustes de apagado",
    "npsCloseSetting": "Ajustes de apagado",
    "SwipeToStart": "Habilitar bloqueo (toque la tarjeta para desbloquear)",
    "ControlPanelToStart": "Deshabilitar bloqueo (operación ilimitada)",
    "Display": "Pantalla",
    "External": "Externa",
    "startingUpMethod": "Habilitar/deshabilitar el bloqueo del panel:",
    "startWith": "Iniciar con:",
    "nmpstartWith": "Encendido sincronizado:",
    "nmpcloseWith": "Apagado sincronizado:",
    "RS232Tip": "Cuando se apaga la alimentación principal, un total de 5 interfaces Serial, incluyendo Serial y hasta 4 CBX, recibirán el código de comando de apagado correspondiente.",

    startPowerTip: 'Al encender, se activan todos los dispositivos conectados a las interfaces de alimentación del CBX.',
    startAirTip: 'Al encender, se encienden todos los aires acondicionados vinculados mediante infrarrojos del dispositivo/CBX.',
    startIrTip: 'Al encender, se envía un comando de enlace por infrarrojo del dispositivo/CBX (por ejemplo, bajar la pantalla, encender el proyector).',
    startRSTip: 'Al encender, se envía un comando de encendido a través de la interfaz Serial del dispositivo/CBX.',
    CloseDisplayTip: 'Los dispositivos conectados a la interfaz DISPLAY se apagarán automáticamente cuando se apague el NDP/NMP. Esta configuración está gestionada por el firmware y no puede modificarse por software.',
    CloseExternalTip: 'Los dispositivos conectados a la interfaz EXTERNAL se apagarán automáticamente cuando se apague el NDP/NMP. Esta configuración está gestionada por el firmware y no puede modificarse por software.',
    ClosePowerTip: 'Al apagar, se desactivan todos los dispositivos conectados a las interfaces de alimentación del CBX.',
    CloseAirTip: 'Al apagar, se apagan todos los aires acondicionados vinculados mediante infrarrojos del dispositivo/CBX.',
    CloseIrTip: 'Al apagar, se envía un comando de enlace por infrarrojo del dispositivo/CBX (por ejemplo, subir la pantalla, apagar el proyector).',
    CloseRSTip: 'Al apagar, se envía un comando de apagado a través de la interfaz Serial del dispositivo/CBX.',
    npsOpenRS232Tip: 'Cuando la alimentación principal se enciende, los dos puertos serie del NPS recibirán los códigos de comando de encendido correspondientes.',
    "npsRS232Tip": "Cuando se apaga la alimentación principal, las dos interfaces Serial de NPS recibirán los códigos de comando de apagado correspondientes.",
    "useCardTip": "Después de desbloquear la tarjeta, la alimentación de los dispositivos se activará automáticamente.",
    "npsCardTip": "Después de desbloquear la tarjeta, la alimentación principal de los dispositivos se activará automáticamente.",
    "PowerOutageHandling": "Manejo de cortes de energía",
    "PowerOutageHandTip": "Para continuar con el acceso durante cortes de energía inesperados, elija 'Desbloquear en caso de corte de energía'. De lo contrario, seleccione 'Bloquear en caso de corte de energía' para restringir el acceso.",
    "acSetting": "Configuración de A/C",
    "ChooseType": "Tipo de dispositivo",
    "ChooseBrand": "Seleccionar una marca",
    "ChooseModel": "Seleccionar un modelo",
    "btnConnectingTest": "Prueba de conexión",
    "LockSetting": "Configuración de cerradura eléctrica",
    "ElectricLockType": "Tipo de cerradura eléctrica:",
    "PowerUNLOCK": "Desbloquear en caso de corte de energía",
    "PowerLOCK": "Bloquear en caso de corte de energía",
    "none": "Ninguno",
    "oddParity": "Paridad impar",
    "EvenParity": "Paridad par",
    "LastSetting": "Última configuración",
    "ElectricLockClosing": "Cierre de la cerradura eléctrica:",
    "manualSwitch": "Interruptor manual",
    "Auto": "Automático (en",
    "projectorSetting": "Selección y vinculación de dispositivos",
    "baudRate": "Velocidad en baudios",
    "Parity": "Paridad",
    "ON": "Encender",
    "OFF": "Apagar",
    "Channel1": "Canal 1",
    "Channel2": "Canal 2",
    "PowerOffDelay": "Retraso de apagado",
    "second": "s",
    "DefaultChannel": "Canal predeterminado",
    "HDMIA": "HDMI salida A:",
    "HDMIB": "HDMI salida B:",
    "HDMIC": "HDMI salida C:",
    "btnSaveApply": "Guardar y aplicar a...",
    "btnSave": "Guardar",
    "btnCustomize": "Personalizado",
    "ACIsPowerTitle": "¿Verificar si el aire acondicionado está encendido?",
    "ACIsPowerContent": "Por favor, apague el aire acondicionado antes de probar. Si no se enciende correctamente, asegúrese de que la marca y el modelo del aire acondicionado sean correctos.",
    "btnNextModel": "No, probar el siguiente modelo",
    "btnYes": "Sí",
    "errorConnecting": "Conexión fallida",
    "hot": "CALIENTE",
    "_MAGNETICLOCK": "Bloqueo electrónico",
    "_AIR": "Aire acondicionado",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    '_AUDIOA': 'HDMI out A',
    '_AUDIOB': 'Audio IN 1',
    '_AUDIOC': 'Audio IN 2',
    "_USB1": "USB 1",
    "_USB2": "USB 2",
    "_USB3": "USB 3",
    "_USBA": "USB A",
    "_USBB": "USB B",
    "IRControl": "Configuración de control IR",
    "acControlTitle": "Seleccionar un dispositivo A/C:",
    "acControlTitleNew": "Dispositivo A/C",
    "intelligentControlTitle": "Seleccionar un dispositivo de control remoto:",
    "intelligentControlTitleNew": "Dispositivo de control remoto",
    "btnACControlCode": "Identificar el nuevo código de control A/C",
    "btnAddRemoteControl": "Nuevo código de control remoto",
    "ACControlCodeTitle": "Identificar código de control A/C",
    "ACControlCodeseft1": "Identificar código",
    "ACControlCodeseft2": "Agregar información",
    "btnStartIdentify": "Iniciar",
    "Identifysuccess": "¡Identificación exitosa!",
    "BeingIdentify": "Analizando...",
    "acBrand": "Marca del A/C",
    "acModel": "Modelo del A/C",
    "IdentifyFailureTitle": "No se encontró el código",
    "IdentifyFailureContent": "La identificación falló, este modelo no es compatible actualmente. Por favor, intente con el control remoto",
    "btnTryAgain": "Intentar de nuevo",
    "btnJump": "Ir al control remoto",
    "ACrideo": "A/C",
    "ortherRideo": "Otros dispositivos",
    "btnBack": "Volver",
    "btnSortOut": "Ir a editar",
    "remoteControlSeft1": "Seleccionar tipo de dispositivo",
    "remoteControlSeft2": "Aprender código",
    "remoteControlSeft3": "Agregar información",
    "addRemoteControlError": "Lo siento, no se pueden aprender más códigos. Por favor, edite primero los códigos de control remoto existentes",
    "btnPrevious": "Anterior",
    "btnNextStep": "Siguiente",
    "remoteControlErrorTitle": "No se pudo aprender el código",
    "remoteControlErrorContent1": "1. El transmisor infrarrojo no está bloqueado",
    "remoteControlErrorContent2": "2. No hay interferencia de luz fuerte alrededor del receptor",
    "remoteControlErrorContent3": "3. El transmisor infrarrojo está instalado correctamente",
    "remoteControlErrorContent4": "4. El control remoto funciona correctamente",
    "deviceItem1": "A/C",
    "deviceItem2": "Proyector",
    "deviceItem3": "TV",
    "deviceItem4": "Ventilador",
    "deviceItem5": "Luz",
    "deviceItem6": "Otros",
    "deviceItem7": "Pantalla interactiva",
    "deviceItem8": "Sistema de captura de conferencias",
    "deviceItem9": "Cámara PTZ",
    "RS232protocol": "Protocolo Serial:",
    "btnRemoteControl": "Iniciar aprendizaje",
    "BeingIdentify1": "Analizando...",
    "Identifysuccess1": "Éxito",
    "controllerType1": "A/C",
    "controllerType2": "Serial",
    "controllerType3": "TV",
    "controllerType4": "Ventilador",
    "controllerType5": "Luz",
    "controllerType9": "Otros",
    "rqRemoteControlCode": "Por favor ingrese el nombre del código del control remoto",
    "rqBrand": "Por favor ingrese la marca del A/C",
    "rqModel": "Por favor ingrese el modelo del A/C",
    "error2016": "El nombre del control remoto está duplicado, por favor ingrese otro",
    "RS232Setting": "Configuración de código serial",
    "IR232Setting": "Configuración IR",
    "SystemError": "Error del sistema. Por favor intente de nuevo",
    "conditionerCodeContent": "No se encuentra el código del aire acondicionado, por favor intente de nuevo",
    "remoteControlCodeContent": "No se encuentra el código del control remoto, por favor intente de nuevo",
    "btnRetry": "Reintentar",
    "Bindusers": "Vincular usuario",
    "tablebinduser": "Vincular usuarios",
    "Refresh": "Actualizar",
    "Binduserlable": "¿Vincular usuarios que pueden controlar el dispositivo ahora?",
    "SaveApplySuccessfully": "Guardar y aplicar con éxito",
    "DeviceType": "Tipo:",
    "tableDeviceType": "Tipo",
    "empty": "Está vacío.",
    "sendCommand": "Enviar más tarde",
    "enable": "Habilitar",
    "disable": "Deshabilitar",
    "SYNCremoteControl": "SINCRONIZAR con control remoto",
    "analysisfailed": "El análisis falló, por favor intente de nuevo",

    "CBX": {
      "powerSupplyON": "Encender",
      "powerSupplyOFF": "Apagar",
      "powerVcrON": "Iniciar grabación",
      "powerVcrOFF": "Detener grabación",
      "lockScreenON": "Bloquear",
      "lockScreenOFF": "Desbloquear",
      "childLockON": "Bloqueo infantil activado",
      "childLockOFF": "Bloqueo infantil desactivado",
      "energySavingON": "Ahorro de energía activado",
      "energySaving": "Ahorro de energía",
      "energySavingOFF": "Ahorro de energía desactivado",
      "signalSourceSwitchingON": "OPS",
      "signalSourceSwitchingOFF": "Android",
      "volumeAdjustment": "Altavoz",
      "brightAdjustment": "Brillo",
      "other": "Otras funciones...",
      "volumeExample": "Funcionalidad Serial completa requerida para la compatibilidad total con el sistema de grabación.",
      "functionCode": "Función:",
      "Name": "Nombre:",
      "controlCode": "Código de control:",
      "brand": "Marca:",
      "model": "Modelo:",
      "errorBrandName": "¡La marca no puede estar vacía!",
      "errorModelName": "¡El modelo no puede estar vacío!"
    }

  },
  "roleMge": {
    "role1": "Usuario general",
    "role101": "Administrador de agente",
    "role102": "Administrador",
    "role4": "Rol personalizado",
    "roleNew": "Nuevo rol",
    "btnAddRole": "Agregar rol",
    "chooseUser": "Elegir usuario",
    "titleLevel": "Nivel de propiedad de transmisión:",
    "titleSettings": "Configuración de permisos:",
    "btnSave": "Guardar",
    "btnDelete": "Eliminar",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "save": "Guardar",
    "addSuccess": "¡Añadido exitosamente!",
    "addError": "¡Falló al agregar!",
    "editSuccess": "¡Editado exitosamente!",
    "editError": "¡Falló al editar!",
    "delSuccess": "¡Eliminado exitosamente!",
    "delError": "¡Falló al eliminar!",
    "V3_0_OrganizationManage": "Gestión de grupos",
    "V3_0_UserManage": "Gestión de usuarios",
    "V3_0_DeviceManage": "Gestión de dispositivos",
    "V3_0_CloudSpaceManage": "Gestión de espacio en la nube",
    "V3_0_OrganizationManage_View": "Ver",
    "V3_0_OrganizationManage_Edit": "Editar",
    "V3_0_UserManage_View": "Ver",
    "V3_0_UserManage_Edit": "Editar",
    "V3_0_DeviceManage_AddDevice": "Agregar dispositivo",
    "V3_0_DeviceManage_Operating": "Operar",
    "V3_0_DeviceManage_Delete": "Eliminar",
    "V3_0_DeviceManage_Edit": "Editar",
    "V3_0_CloudSpaceManage_PersonalManage": "Gestión de la nube personal",
    "V3_0_CloudSpaceManage_PublicManage": "Gestión de la nube pública",
    "V3_0_CloudSpaceManage_SpaceManage": "Asignación de espacio",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "Operación",
    "V3_0_CloudSpaceManage_PersonalManage_View": "Ver",
    "V3_0_CloudSpaceManage_PublicManage_View": "Ver",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "Subir",
    "V3_0_CloudSpaceManage_PublicManage_Download": "Descargar",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "Eliminar archivo",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "Editar carpeta",
    "delTitle": "¿Eliminar?",
    "delTitleContent": "El contenido seleccionado se eliminará de la base de datos. Esta operación no se puede deshacer. ¿Está seguro de que desea continuar?",
    "delCancelButton": "Cancelar",
    "delConfirmButton": "Confirmar",
    "btnAdd": "Agregar rol",
    "RoleName": "Nombre del rol:",
    "ManageRange": "Rango de gestión:",
    "ChooseUser": "Elegir usuario:",
    "PermissionSettings": "Configuraciones de permisos:",
    "BroadcastingPropertyLevel": "Nivel de propiedad de transmisión",
    "ChooseGroups": "Elegir grupos",
    "ChooseTheUser": "Elegir usuario",
    "deleleTitle": "El nuevo rol no ha sido guardado. Si sale, el rol será eliminado. ¿Está seguro de que desea salir?",
    "Error1601": "No se puede usar administrador",
    "Error1602": "Error al obtener el rol de permiso",
    "Error1603": "Solo los administradores tienen acceso a estas funciones",
    "Error1604": "El nombre del rol no puede estar vacío",
    "Error1605": "El grupo no puede estar vacío",
    "Error1606": "Este rol ya existe",
    "Error1607": "Rol definido por el sistema, no se permite la modificación",
    "Error1608": "Error al configurar el rol",
    "Error1609": "Rol de usuario común del sistema, no se permite la modificación",
    "Error1610": "Por favor, use el rol de administrador de terminal para realizar las operaciones relacionadas",
    "Error1611": "No tiene los permisos de rol correspondientes"
  },
  "projectorDevicesMge": {
    "tipOne": "1. Complete el nombre de la función y el código de control. Los ejemplos de código utilizan formato HEX.",
    "tipTwo": "2. Esta interfaz es solo para la configuración de comandos serie de encendido/apagado. Vaya a 'Gestión de dispositivos / Dispositivos / Operaciones / Configuración de energía' para habilitar la función.",
    "tipFunctionOne": "1. Seleccione funciones comunes de la lista desplegable. Los iconos correspondientes se mostrarán en la interfaz de control serie del panel inteligente.",
    "tipFunctionTwo": "2. Los comandos 'POWER ON' y 'POWER OFF' se utilizan para el enlace serie de encendido/apagado del dispositivo. Esta página solo configura códigos de control. Vaya a 'Gestión de dispositivos / Dispositivos / Operaciones / Configuración de energía' para habilitar la función de enlace.",
    "ListRS232functions": "Lista de funciones de control en serie",
    "Customizefunctionlist": "Personalizar la lista de funciones",
    "btnAddProjectorCode": "Agregar código de serie",
    "btnDel": "Eliminar",
    "inputSeach": "Buscar",
    "btnEdit": "Editar",
    "cancel": "Limpiar",
    "confirm": "Confirmar",
    "tableName": "Nombre del código",
    "tablersType": "Tipo de dispositivo:",
    "tablersTypeTable": "Tipo de dispositivo",
    "tableModel": "Modelo",
    "tableBrand": "Marca",
    "tableActions": "Acciones",
    "dialogAddTitle": "Agregar código Serial",
    "dialogEditTitle": "Editar código Serial",
    "brand": "Nombre de la marca:",
    "model": "Modelo:",
    "baudRate": "Velocidad en baudios:",
    "parity": "Paridad:",
    "powerOn": "ENCENDER",
    "powerOff": "APAGAR",
    "pgrInput1": "Canal 1",
    "pgbInput2": "Canal 2",
    "delTitle": "¿Eliminar?",
    "delTitleContent": "El contenido seleccionado se eliminará de la base de datos. Esta operación no se puede deshacer. ¿Está seguro de que desea continuar?",
    "delCancelButton": "Cancelar",
    "delConfirmButton": "Confirmar",
    "content": "Buscar",
    "operate": "Acciones",
    "tableDel": "Eliminar",
    "tableEdit": "Editar",
    "addSuccess": "¡Agregado exitosamente!",
    "addError": "¡Error al agregar!",
    "editSuccess": "¡Editado exitosamente!",
    "editError": "¡Error al editar!",
    "delSuccess": "¡Eliminado exitosamente!",
    "delError": "¡Error al eliminar!",
    "selectTitle": "¡Por favor seleccione un Serial!",
    "selectCode": "Seleccionar Serial",
    "none": "Ninguno",
    "oddParity": "Paridad impar",
    "EvenParity": "Paridad par"
  },
  "authorityMge": {
    "V3_0_OrganizationManage": "Gestión de grupos",
    "V3_0_UserManage": "Gestión de usuarios",
    "V3_0_DeviceManage": "Gestión de dispositivos",
    "V3_0_CloudSpaceManage": "Gestión de espacio en la nube",
    "V3_0_OrganizationManage_View": "Ver",
    "V3_0_OrganizationManage_Edit": "Editar",
    "V3_0_UserManage_View": "Ver",
    "V3_0_UserManage_Edit": "Editar",
    "V3_0_DeviceManage_AddDevice": "Agregar dispositivo",
    "V3_0_DeviceManage_Operating": "Operar",
    "V3_0_DeviceManage_Delete": "Eliminar",
    "V3_0_DeviceManage_Edit": "Editar",
    "V3_0_DeviceManage_RepairLog": "Registro de reparación",
    "V3_0_CloudSpaceManage_PersonalManage": "Gestión de nube personal",
    "V3_0_CloudSpaceManage_PublicManage": "Gestión de nube pública",
    "V3_0_CloudSpaceManage_SpaceManage": "Gestión de espacio en la nube",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "Operar",
    "V3_0_CloudSpaceManage_PersonalManage_View": "Ver",
    "V3_0_CloudSpaceManage_PublicManage_View": "Ver",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "Subir",
    "V3_0_CloudSpaceManage_PublicManage_Download": "Descargar",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "Eliminar",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "Editar",
    "delTitle": "¿Eliminar?",
    "delTitleContent": "Los componentes seleccionados serán eliminados de la base de datos. Este proceso es irreversible. ¿Está seguro de que desea continuar?",
    "delCancelButton": "Cancelar",
    "delConfirmButton": "Confirmar",
    "content": "Buscar",
    "operate": "Acción",
    "tableDel": "Eliminar",
    "tableEdit": "Editar",
    "addSuccess": "¡Agregado con éxito!",
    "addError": "¡Fallo al agregar!",
    "editSuccess": "¡Editado con éxito!",
    "editError": "¡Fallo al editar!",
    "delSuccess": "¡Eliminado con éxito!",
    "delError": "¡Fallo al eliminar!",
    "selectTitle": "¡Seleccione Serial!"
  },
  "workstationMge": {
    "priorChoice": "Preferencia de transmisión:",
    "SpeedPriority": "Prioridad de velocidad",
    "SyncPriority": "Prioridad de sincronización de cuadros",
    "SpeedPriorityTip": "Después de enviar las instrucciones de transmisión AV, los terminales Q-NEX pueden realizar la tarea de reproducción en un tiempo de búfer más corto, alrededor de 3-5 segundos. Se recomienda encarecidamente la prioridad de velocidad cuando el servidor de medios funciona en LAN.",
    "SyncPriorityTip": "Después de enviar las instrucciones de transmisión AV, los terminales Q-NEX pueden realizar la tarea de reproducción de manera sincronizada con un tiempo de búfer de alrededor de 8-12 segundos.",
    "btnAddMedia": "Agregar servidor de medios",
    "btnBack": "Atrás",
    "tableMediaLibId": "ID del servidor de medios",
    "tableMediaLibName": "Nombre del servidor de medios",
    "tableState": "Estado de la red",
    "tableBindingUsers": "Usuarios vinculados",
    "tableLiveAddress": "Dirección de transmisión",
    "tableAddress": "Dirección de streaming",
    "tableOperate": "Acciones",
    "tableDel": "Eliminar",
    "tableEdit": "Editar",
    "titleMediaStation": "Dirección de transmisión",
    "titleLiveStation": "Dirección de streaming:",
    "radioPublic": "Pública",
    "radioPrivate": "Privada",
    "btnSave": "Guardar",
    "titleUsers": "Usuarios",
    "titleCanBe": "Se puede vincular",
    "titleHaveBeen": "Ya vinculado",
    "titleMore": "¿Necesitas agregar más?",
    "btnAdd": "Agregar",
    "content": "Buscar",
    "tableName": "Nombre",
    "tableUserName": "Nombre de usuario",
    "operate": "Acciones",
    "affiliatedOrganization": "Grupos",
    "dialogTitle": "Agregar nuevo servidor de medios",
    "dialogTitleEdit": "Editar nuevo servidor de medios",
    "dialogItemName": "Nombre:",
    "dialogItemId": "ID:",
    "dialogItemIp": "Dirección de difusión:",
    "titleSelectUsers": "Seleccionar usuarios",
    "selectMedia": "Por favor, elija un medio",
    "delTitle": "¿Está seguro de que desea eliminar?",
    "delMediaLibTitle": "¿Confirmación de eliminación?",
    "delTitleContent": "Los elementos seleccionados se eliminarán de la base de datos. Esta operación no se puede deshacer. ¿Está seguro de que desea continuar?",
    "delTitleMediaLibContent": "La acción de eliminación hará que los datos relevantes se eliminen y no se podrá revertir.",
    "delCancelButton": "Cancelar",
    "delConfirmButton": "Confirmar",
    "selectDevices": "Por favor, seleccione dispositivos",
    "selectUser": "Por favor, seleccione usuarios",
    "addUser": "Agregar usuario",
    "editUser": "Editar usuario",
    "addSuccess": "¡Agregado exitosamente!",
    "addError": "¡Error al agregar!",
    "editSuccess": "¡Editado exitosamente!",
    "editError": "¡Error al editar!",
    "delSuccess": "¡Eliminado exitosamente!",
    "delError": "¡Error al eliminar!",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "save": "Guardar",
    "error2500": "Se excedió el número máximo de dispositivos que se pueden conectar a la estación de trabajo actual.",
    "DeviceName": "Nombre del dispositivo",
    "AssociatedUserManagement": "Gestión de usuarios asociados",
    "btnDel": "Eliminar",
    "errorMsgId": "No se puede encontrar este ID",
    "LiveStreaming": "Dirección de streaming:",
    "NoFoundMediaId": "No se puede obtener el ID del servidor de medios",
    "AlreadyConnectedOrg": "El servidor multimedia ya está asociado con otra organización",
    "AlreadyBoundMedia": "Esta organización ya ha vinculado un servidor multimedia, y no puede vincular otro más",
    "DeleteSecondaryConfirmation": "Los datos no se pueden recuperar después de eliminar el servidor multimedia, por favor confirme nuevamente."
  },
  "cloudDiskMge": {
    "totalStorage": "ALMACENAMIENTO TOTAL",
    "GetMore": "Obtener más",
    "StorageSpace": "Espacio de almacenamiento",
    "Adjustment": "Ajuste",
    "moreSpace": "Obtener más espacio de almacenamiento",
    "PublicStorage": "Almacenamiento público",
    "PublicStorageUsed": "Almacenamiento público utilizado",
    "PublicStorageLasted": "Almacenamiento público restante",
    "IndividualStorageUsed": "Almacenamiento personal utilizado",
    "IndividualStorageLasted": "Almacenamiento personal restante",
    "storageSpace": "Ajuste de espacio de almacenamiento",
    "tableUserName": "Nombre de usuario",
    "tableUsedSpace": "Espacio utilizado",
    "tableAvailableSpace": "Espacio disponible",
    "tableActiveTime": "Última hora activa",
    "tableOperate": "Acciones",
    "cleanup": "Nota para limpiar",
    "IndividualStorageSpaceAdjustment": "Ajuste de espacio de almacenamiento personal",
    "titleTotal": "Total",
    "PublicDisk": "Nube pública",
    "IndividualDisk": "Nube personal",
    "PerUser": "Por usuario",
    "UsersInTotal": "Total de usuarios",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "save": "Guardar",
    "addSuccess": "¡Añadir con éxito!",
    "addError": "¡Error al añadir!",
    "editSuccess": "¡Edición exitosa!",
    "editError": "¡Error al editar!",
    "delSuccess": "¡Eliminado con éxito!",
    "delError": "¡Error al eliminar!",
    "error3000": "La operación falló porque se ha superado el tamaño total del almacenamiento.",
    "error3003": "Operación fallida, por favor verifica si se ha configurado un servidor multimedia.",
    "IndividualStorage": "Almacenamiento personal",
    "NoteToCleanup": "Nota para limpiar",
    "updatePersonalSuccess": "Tu espacio de almacenamiento en la nube se llenará, por favor limpia a tiempo",
    "updatePersonalSuccess1": "Modificado y guardado con éxito",
    "storageUsage": "Uso del almacenamiento personal",
    "bindIndividualstorage": "Usuarios autorizados para tener almacenamiento en la nube personal",
    "UserIndividualstorage": "Usuarios que ya han configurado almacenamiento en la nube personal",
    "Notificationsuccessfully": "Notificación enviada con éxito",
    "Notificationfailed": "Error al enviar la notificación",
    "tableName": "Nombre",
    "userID": "ID de usuario"
  },
  "dashboard": {
    "exportPdf": "Exportar PDF",
    "or": "-",
    "warrantyCompletionRate": "Tasa de reparación",
    "frequencyOfEachModule": "El porcentaje de reparación de cada módulo funcional",
    "repairHandling": "Estado de procesamiento de la reparación",
    "sourceSwitchInput": "Interruptor de entrada",
    "micVol": "Volumen del micrófono",
    "volumeSpeaker": "Volumen del altavoz",
    "airAonditioner": "Aire acondicionado",
    "Curtain": "Pantalla del proyector",
    "remoteControlIntelligent": "Control remoto",
    "RS232Control": "Control Serial",
    "lockElectronic": "Cerraduras electrónicas",
    "Repairreportcompleted": "Reparado",
    "Totalnumberofrepairsreported": "Reparaciones totales",
    "Warrantycompletionrate": "Tasa de finalización de la reparación",
    "startDate": "Fecha de inicio",
    "endDate": "Fecha de finalización",
    "year": "Año",
    "month": "Mes",
    "dayTian": "Día",
    "placeholderDate": "Seleccionar fecha",
    "placeholderDateTime": "Seleccionar hora",
    "devicesNub": "Dispositivos",
    "userNub": "Usuarios",
    "powerNub": "Potencia (KW/H)",
    "storageUsed": "Almacenamiento utilizado (%)",
    "userLoginDevice": "Período activo de inicio de sesión de usuario",
    "devicePowerConsumption": "Consumo de electricidad diario de todos los dispositivos",
    "externalDeviceUsageTime": "Uso de dispositivos externos",
    "equipmentRunningTime": "Uso de dispositivos terminales",
    "cloudStorageSpace": "Uso del almacenamiento",
    "powerConsumptionPort": "Consumo de energía de cada puerto de alimentación",
    "mostPopularFile": "Archivo más popular",
    "commonFunctions": "Funciones comunes",
    "commonlyUsed": "Método de transmisión más utilizado",
    "fileName": "Nombre del archivo",
    "usageCount": "Número de usos",
    "electricityConsumption": "Consumo de electricidad",
    "publicStorageUsed": "Almacenamiento público utilizado",
    "publicStorageLasted": "Almacenamiento público restante",
    "individualStorageUsed": "Almacenamiento individual utilizado",
    "individualStorageLasted": "Almacenamiento individual restante",
    "notification": "Notificación",
    "audioBroadcast": "Transmisión de audio",
    "videoBroadcast": "Transmisión de video",
    "ac": "Aire acondicionado",
    "hDMISwitch": "Interruptor HDMI",
    "powerControl": "Control de energía",
    "powercontrol": "Control de energía",
    "Lock": "Bloquear",
    "volumeAdjust": "Ajuste de volumen",
    "projectionScreen": "Pantalla de proyección",
    "today": "Hoy",
    "yesterday": "Ayer",
    "thisWeek": "Esta semana",
    "lastWeek": "La semana pasada",
    "lastMonth": "El mes pasado",
    "thisMonth": "Este mes",
    "times": "Veces",
    "usage": "Número de usos",
    "eachrTitle": "Minutos",
    "total": "Total",
    "NMPSystemissue": "Problema del sistema NMP",
    "displayPower": "Problema del dispositivo externo NMP",
    "externalPower": "Problema del sistema MBX",
    "screen": "Problema del dispositivo externo MBX",
    "TotalRepairs": "Total de reparaciones",
    "Repaired": "Reparado",
    "Unrepaired": "No reparado",
    "day": "DÍA",
    "Minutes": "Minutos",
    "powerConsumption": "Minutos",
    "Date": "Fecha",
    "kw": "KW",
    "month1": "LUN",
    "month2": "MAR",
    "month3": "MIÉ",
    "month4": "JUE",
    "month5": "VIE",
    "month6": "SÁB",
    "month7": "DOM",
    "enmonth1": "Ene",
    "enmonth2": "Feb",
    "enmonth3": "Mar",
    "enmonth4": "Abr",
    "enmonth5": "May",
    "enmonth6": "Jun",
    "enmonth7": "Jul",
    "enmonth8": "Ago",
    "enmonth9": "Sep",
    "enmonth10": "Oct",
    "enmonth11": "Nov",
    "enmonth12": "Dic",
    "noData": "Sin datos"
  },
  "input": {
    "fivedigits": "Por favor ingrese un número entero positivo de 5 dígitos",
    "titlUserNameField": "Este nombre de usuario debe ser completado",
    "thisField": "Este campo debe ser completado",
    "ChooseGroup": "Elegir grupo",
    "placeholder": "Seleccionar",
    "placeholder_type": "Por favor seleccione los tipos de control de dispositivo",
    "titlRealNameField": "La contraseña debe ser completada",
    "thisPasswordField": "La contraseña debe ser completada",
    "titlPassWordNub": "Menos de 15 letras",
    "Post": "Solo números",
    "passwordNoChinese": "Esta caja de entrada no puede llenarse con caracteres chinos"
  },
  "transfer": {
    "all": "Todo",
    "Choose": "Elegir",
    "Selected": "Seleccionado",
    "Subordinate": "Subordinado"
  },
  "setting": {
    limitPngGif: 'Solo se admiten formatos PNG / GIF',
    limit3M: 'El tamaño de la imagen no puede superar los 3 MB',
    setting_door_Wallpaper_text: 'Tamaño de imagen recomendado: 1280x800, formato PNG o GIF',

    "reduction": "Restaurar",
    "limitJpg": "¡La imagen de perfil subida solo puede ser en formato PNG!",
    "limit2M": "¡El tamaño de la imagen de perfil subida no debe exceder los 2 MB!",
    "choseFile": "Seleccionar archivo",
    "textOne": "1. Imagen LOGO recomendada: tamaño 117*40, en formato PNG",
    "textTwo": "2. Después de subirla, por favor vaya al Panel Táctil, asegúrese de que el Panel Táctil esté conectado a Internet y luego haga clic en el logo original para actualizar.",
    "customizeLogo": "Configuración del logo del Panel Táctil",
    "addSuccess": "¡Configuración exitosa!",
    "settingIp": "Configuración de la dirección IP de almacenamiento de archivos",
    "ServerIP": "Dirección IP del servidor:",
    "ServerPort": "Puerto del servidor:",
    "btnSave": "Guardar",
    "TimeZoneSetting": "Configuración de zona horaria",
    "CurrentTime": "Hora actual:",
    "CurrentTimeZone": "Zona horaria actual:",
    "httpsSetting": "Almacenamiento de archivos:",
    "utcName": "Hora Media de Greenwich UTC/GMT",
    "utc0": "Hora Media de Greenwich, Reino Unido, Lisboa, Torshavn, Londres, Dublín, Edimburgo",
    "utc0_5": "",
    "utc1": "Europa Central, África Occidental, África Occidental Central, Alemania, Irlanda, Francia, Ámsterdam, Italia, Berlín, Roma, España, Praga, Belgrado, Bruselas, París, Madrid, Túnez, Gabón, Marruecos",
    "utc1_5": "",
    "utc2": "Europa del Este, África Central, Turquía, Israel, Sudáfrica, Estambul, El Cairo, Atenas, Damasco",
    "utc2_5": "",
    "utc3": "África Oriental, Rusia, Bagdad, Kuwait, Moscú, San Petersburgo",
    "utc3_5": "Irán",
    "utc4": "Abu Dabi, Tiflis, Dubái, Mauricio, Port Louis",
    "utc4_5": "Afganistán",
    "utc5": "Pakistán, Turkmenistán, Maldivas, Uzbekistán, Armenia, Tayikistán India, Mumbai, Nueva Delhi, Bangalore, Calcuta",
    "utc5_5": "India, Sri Lanka",
    "utc6": "Novosibirsk, Kirguistán, Bangladesh, Bután",
    "utc6_5": "Islas Cocos Australia, Vietnam",
    "utc7": "Tailandia, Bangkok, Hanoi, Yakarta",
    "utc7_5": "",
    "utc8": "China, Malasia, Filipinas, Singapur, Taiwán China, Macao China, Hong Kong China",
    "utc8_5": "",
    "utc9": "Japón, Corea del Sur, Tokio, Seúl, Sapporo, Osaka, Timor Oriental",
    "utc9_5": "Hora estándar central australiana",
    "utc10": "Australia, Vladivostok, Guam, Canberra, Melbourne, Sídney, Papúa Nueva Guinea",
    "utc10_5": "Isla Lord Howe de Nueva Gales del Sur, Australia",
    "utc11": "Islas Salomón, Isla Sakhalin",
    "utc11_5": "Isla Norfolk, Australia",
    "utc12": "Nueva Zelanda, Auckland, Wellington, Fiyi, Nueva Zelanda, Nauru",
    "utc12_5": "",
    "utc13": "Cabo Verde, Azores",
    "utc13_5": "",
    "utc14": "Georgia del Sur, Fernando de Noronha",
    "utc14_5": "",
    "utc15": "Brasil, Santiago, El Salvador, Brasilia, Uruguay, Argentina, Surinam",
    "utc15_5": "Hora estándar de Terranova",
    "utc16": "Venezuela, Bolivia, Paraguay, Chile",
    "utc16_5": "Venezuela",
    "utc17": "Hora del Este (EE.UU. y Canadá), Colombia, Toronto, Ecuador, Perú, Cuba, Nueva York, Hamilton, San Diego",
    "utc17_5": "",
    "utc18": "Hora central de EE.UU. y Canadá, Ciudad de México, Monterrey, Chicago, Houston, Nueva Orleans, Memphis",
    "utc18_5": "",
    "utc19": "Hora de las Montañas, Arizona, Mazatlán, Phoenix, Salt Lake City, Denver, Edmonton",
    "utc19_5": "",
    "utc20": "Hora del Pacífico, Los Ángeles, San Francisco, Vancouver, Seattle, Las Vegas",
    "utc20_5": "",
    "utc21": "Alaska",
    "utc21_5": "Polinesia Francesa, Islas Marquesas",
    "utc22": "Hawái",
    "utc22_5": "",
    "utc23": "Samoa, Niue",
    "utc23_5": "",
    "utc24": ""
  },
  "repairLog": {
    "DeviceName": "Nombre del dispositivo:",
    "Time": "Hora:",
    "startDate": "Fecha de inicio",
    "endedDate": "Fecha de finalización",
    "or": "-",
    "Problem": "Problema:",
    "btnSearch": "Buscar",
    "tableNO": "No",
    "tableDeviceName": "Nombre del dispositivo",
    "tableGroup": "Grupo",
    "tableStatus": "Estado",
    "tableDeliveredTime": "Hora de entrega",
    "tableSubmitter": "Remitente",
    "tableUpdatingTime": "Hora de actualización",
    "tableProblem": "Problema",
    "tableAdmin": "IT-Admin",
    "tableAdminReply": "Respuesta del administrador",
    "tableAttachment": "Adjunto",
    "state0": "Entregado",
    "state1": "En proceso",
    "state2": "Completado",
    "Problem100": "TODO",
    "Problem0": "Problema del sistema",
    "Problem1": "Problema del dispositivo externo",
    "ProblemType": "",
    "ProblemType0": "Control de energía",
    "ProblemType1": "Interruptor HDMI",
    "ProblemType2": "Micrófono",
    "ProblemType3": "Altavoz",
    "ProblemType4": "Aire acondicionado",
    "ProblemType5": "Pantalla del proyector",
    "ProblemType6": "Cerradura eléctrica",
    "ProblemType7": "Difusión A/V",
    "ProblemType8": "Control IR",
    "ProblemType9": "Control Serial",
    "dialogDeviceName": "Nombre del dispositivo",
    "dialogDeviceID": "ID del dispositivo",
    "dialogGroup": "Grupo",
    "dialogSubmitter": "Remitente",
    "dialogStatus": "Elija el estado",
    "dialogProblem": "Problema",
    "dialogNotes": "Notas",
    "dialogRepairation": "Reparación",
    "dialogInProcess": "En proceso",
    "dialogCompleted": "Completado",
    "editSuccess": "¡Edición exitosa!",
    "editError": "¡Error al editar!",
    "problemRequired": "Seleccione un tipo de problema",
    "detailRequired": "Describa el problema en detalle",
    "statusRequired": "Elija el estado del registro",
    "btnCancel": "Cancelar",
    "DeliveredTime": "Hora de entrega",
    "UpdatingTime": "Hora de actualización",
    "ITAdmin": "IT-Admin",
    "AdminReply": "Respuesta del administrador",
    "Note": "Nota",
    "Detail": "Detalle",
    "controlPanel": "Panel de control",
    "DeviceType": "Tipo",
    "dialogDeliveredTime": "Hora de entrega",
    "Submitter": "Remitente"
  },
  "remoteControl": {
    "QuickActionName": "Nombre",
    "DeviceType": "Tipo",
    "Description": "Descripción",
    "tableDescription": "Descripción",
    "editRemoteControl": "Editar código de control remoto",
    "QuickActionNameInput": "Nombre",
    "DescriptionInput": "Descripción",
    "save": "Guardar",
    "Brand": "Marca",
    "Model": "Modelo",
    "EditACControlCode": "Editar código de control de A/C",
    "acBrand": "Marca de A/C",
    "acModel": "Modelo de A/C"
  },
  "card": {
    "btnAddCard": "Añadir tarjeta",
    "btnBatchAddCard": "Añadir tarjetas por lotes",
    "tableCard": "Número de tarjeta",
    "tableState": "Estado",
    "tableUser": "Usuario vinculado",
    "tableID": "Nombre de usuario",
    "tableType": "Tipo de tarjeta",
    "tableFfective": "Fecha de caducidad",
    "dialogCard": "Número de tarjeta :",
    "dialogState": "Estado :",
    "dialogUser": "Usuario vinculado :",
    "dialogID": "Nombre de usuario :",
    "dialogType": "Tipo de tarjeta :",
    "dialogFfective": "Fecha de caducidad :",
    "dialogRemarks": "Comentarios :",
    "dialogAddTitle": "Añadir tarjeta",
    "dialogEidtTitle": "Editar tarjeta",
    "code2201": "El formato del período de caducidad de la tarjeta es incorrecto",
    "code2202": "Esta tarjeta ya está vinculada",
    "code2203": "Este usuario ya está vinculado",
    "code2204": "Esta tarjeta no está vinculada",
    "mastCard": "Tarjeta maestra",
    "regularCard": "Tarjeta general",
    "permanent": "Permanente",
    "coxPermanent": "Permanente",
    "coxTime": "Período determinado",
    "tableDeviceName": "Nombre del dispositivo",
    "tableDeviceID": "ID del dispositivo",
    "tableOperating": "Operación",
    "tableOperatingTime": "Tiempo de operación",
    "tableCardID": "Número de tarjeta",
    "tableCardType": "Tipo de tarjeta",
    "tabluserName": "Nombre de usuario",
    "tabluserId": "ID de usuario",
    "unlockPanel": "Desbloquear panel",
    "unlock": "Desbloquear puerta",
    "conAll": "Todo",
    "btnEnable": "Habilitar",
    "btnDisable": "Deshabilitar",
    "enableSuccess": "Habilitación exitosa",
    "stopSuccess": "Deshabilitación exitosa",
    "enableError": "Error al habilitar",
    "stopError": "Error al deshabilitar",
    "batchCard": "Número de tarjeta por lotes :",
    "titlCardField": "El número de tarjeta no puede estar vacío",
    "titlCardFieldFormat": "Solo letras y números",
    "dialogBachAddTitle": "Añadir tarjetas por lotes",
    "pleaseTryAgain1": "Número de tarjeta incorrecto (NO. :",
    "pleaseTryAgain2": "), por favor intente de nuevo"
  },
  privacy: {
    PrivacyPolicy: 'Microsoft Organization Binding Privacy Agreement',
    Byusing: 'Dear User,',
    whatinformation: 'Before authorizing Q-NEX to access Microsoft data, please read this agreement carefully. This document is a supplement to the Q-NEX Privacy Policy, and it specifically explains the permissions required for synchronization, the purposes of data usage, and our protection measures. By checking “Agree,” you confirm that you have read and accepted all terms of this agreement.',
    EffectiveDate: 'Effective Date: August 4, 2025',
    title1: 'Required Permissions & Collected Data',
    title1Respects1: 'To enable synchronization between Q-NEX Room Scheduler and Microsoft Calendar, Q-NEX requires the following Microsoft permissions:',
    title1Respects2: 'Delegated Permissions',
    Respects2formation: 'These permissions allow Q-NEX to access your Microsoft account data after login and consent:',
    Respects2formation2: 'Calendars.ReadWrite',
    Respects2formation3: 'Permission Name: Full access to user calendars',
    Respects2formation4: 'Description: Allows the app to create, read, update, and delete events in user calendars.',
    Respects2formation5: 'Purpose: Synchronize personal calendar meetings with the Q-NEX system.',
    Respects2formation6: 'offline_access',
    Respects2formation7: 'Permission Name: Maintain access to data you’ve granted',
    Respects2formation8: 'Description: Allows the app to access authorized data even when you’re not actively using it.',
    Respects2formation9: 'Purpose: Ensures meeting information remains synced even when users are offline.',
    Respects2formation10: 'Openid',
    Respects2formation11: 'Permission Name: Sign in as you',
    Respects2formation12: 'Description: Enables login via work/school accounts and allows the app to read basic profile details.',
    Respects2formation13: 'Purpose: Authenticates user identity for security and associates profiles with meeting data.',
    Respects2formation14: 'Place.Read.All',
    Respects2formation15: 'Permission Name: Read all company places',
    Respects2formation16: 'Description: Allows the app to read company locations (meeting rooms and room lists) on your behalf.',
    Respects2formation17: 'Purpose: Retrieves company room resource lists and syncs meeting room booking statuses.',

    tp1: 'Application Permissions (Requires Admin Consent)',
    tp2: 'These permissions enable Q-NEX to sync data automatically without manual reauthorization:',
    tp3: 'Calendars.ReadWrite',
    tp4: 'Permission Name: Read and write calendars in all mailboxes',
    tp5: 'Description: Allows the app to create, read, update, and delete calendar events without user sign-in.',
    tp6: 'Purpose: Syncs schedules from all company meeting room resource mailboxes.',
    tp7: 'Directory.Read.All',
    tp8: 'Permission Name: Read directory data',
    tp9: 'Description: Allows the app to read organizational directory data (users, groups, apps) without user sign-in.',
    tp10: 'Purpose: Validates meeting room resource mailboxes and retrieves organizational structure.',
    tp11: 'User.Read.All',
    tp12: 'Permission Name: Read all users’ full profiles',
    tp13: 'Description: Allows the app to read user profiles without user sign-in.',
    tp14: 'Purpose: Identifies meeting participants.',
    tp15: 'Place.Read.All',
    tp16: 'Permission Name: Read all company places',
    tp17: 'Description: Allows the app to read company locations (meeting rooms and room lists) for calendar events and other apps without user sign-in.',
    tp18: 'Purpose: Retrieves full meeting room resource lists and syncs availability statuses.',

    title2: 'Purpose of Data Usage',
    title2Respects1: 'Sync Microsoft Calendar meetings to Q-NEX for real-time display on the Room Scheduler.',
    title2Respects2: 'Automatically update room availability to prevent scheduling conflicts.',
    title2Respects3: 'Provide a unified meeting management experience.',

    title3: 'Data Storage & Protection',
    title3Respects1: 'All synced data is encrypted and stored on Q-NEX servers, used solely for this functionality.',
    title3Respects2: 'Q-NEX does not share calendar data with third parties unless legally required or for system security.',
    title3Respects3: 'For cross-border data transfers, we will ensure compliance with applicable laws through contractual terms or certification mechanisms.',

    title4: 'Your Rights',
    title4Respects1: 'You may unbind your Microsoft account at any time via the Q-NEX Console to stop data synchronization.',

    title5: 'Important Notes',
    title5Respects1: 'Please ensure you have administrative rights or legal authorization for the Microsoft account you bind.',
    title5Respects2: 'Once unbound, Q-NEX will stop syncing new data, but historical data may be retained for a certain period as required by compliance obligations.',

    contactInformation: 'Contact Information',
    contactInformationContent: 'If you have any questions, please contact: info@qnextech.com',

  }
}



// WEBPACK FOOTER //
// ./src/lang/es.js